module.exports = __webpack_public_path__ + "static/computility.abcab870.png";